module.exports = __webpack_public_path__ + "static/media/Rec-3-03.126f0124.webp";